/**
 * NatureOfBusiness option labels (HLD §4.1 / PRD Appendix A).
 * Snake_case GraphQL enum members land with COMP-4645 codegen — labels are stable for FE selects.
 */
export const NATURE_OF_BUSINESS_OPTIONS = [
  "Banking & Credit Institutions",
  "Cannabis & Related Activities",
  "Family Office",
  "Gambling & Gaming",
  "Hedge Fund",
  "Holding Company / SPV",
  "Trust & Fiduciary Services",
  "Trust & Company Service Providers (TCSPs)",
  "Pension Funds",
  "Insurance & Reinsurance",
  "Private Equity",
  "Real Estate Assets (REITs/Development)",
  "Professional Services (Legal, Accounting, Consulting)",
  "Technology & Software (SaaS, Fintech)",
  "Non-Profit / NGO",
  "Government / Public Sector Entity",
  "Venture Capital",
  "Virtual Assets (Crypto, Web3, Exchanges)",
  "Sovereign Wealth Funds",
  "Payment Services / Money Services Business (MSB)",
  "Broker-Dealer / Market Maker",
  "Foundations & Endowments",
  "Natural Resources (Mining, Oil & Gas)",
  "Arms, Defense & Security",
  "Art, Antiquities & High-Value Collectibles",
  "Dealers in Precious Metals & Stones (DPMS)",
  "Hospitality & Entertainment",
  "Other",
] as const;

export type NatureOfBusinessOption = (typeof NATURE_OF_BUSINESS_OPTIONS)[number];
